import { FloatingIndicator, Tabs } from '@mantine/core';
import { IconListDetails, IconMessages, IconPhoto } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CommunityFeed } from '../CommunityFeed';
import { JournalFeed } from '../CommunityFeed/JournalFeed';
import { PhotoAlbums } from '../CommunityTheFuture/PhotoAlbums';

import styles from './CommunityTabs.module.scss';

const CommunityTabs = () => {
  const { t } = useTranslation();
  // Les valeurs des onglets sont immuables (deep links, tracking) : seuls le contenu
  // et les libellés changent.
  const communityFeed = <CommunityFeed />;
  const photos = <PhotoAlbums />;
  const journal = <JournalFeed variant="full" />;

  const [currentTab, setCurrentTab] = useState<string | null>('community');
  const [tabsListRef, setTabsListRef] = useState<HTMLDivElement | null>(null);
  const [tabsRef, setTabsRef] = useState<Record<string, HTMLButtonElement | null>>({});
  const setTabRef = (val: string) => (node: HTMLButtonElement) => {
    tabsRef[val] = node;
    setTabsRef(tabsRef);
  };

  return (
    <div className={styles.screen}>
      <Tabs
        variant="unstyled"
        inverted
        value={currentTab}
        onChange={setCurrentTab}
        keepMounted={false}
        classNames={{
          root: styles.tabs,
          tab: styles.tab,
          tabLabel: styles.tabLabel,
          panel: styles.panel,
          list: styles.list,
        }}
      >
        <Tabs.Panel value="community">{communityFeed}</Tabs.Panel>

        <Tabs.Panel value="future">{journal}</Tabs.Panel>

        <Tabs.Panel value="my-profile">{photos}</Tabs.Panel>

        <Tabs.List ref={setTabsListRef} grow>
          <div className={styles.blurryEdge} />

          <Tabs.Tab ref={setTabRef('community')} value="community">
            <IconMessages size={24} />

            {t('community.tabs.chat', 'le Tchat')}
          </Tabs.Tab>

          <Tabs.Tab ref={setTabRef('future')} value="future">
            <IconListDetails size={24} />

            {t('community.tabs.journal', 'Journal')}
          </Tabs.Tab>

          <Tabs.Tab ref={setTabRef('my-profile')} value="my-profile">
            <IconPhoto size={24} />

            {t('community.tabs.photos', 'Photos')}
          </Tabs.Tab>

          <FloatingIndicator
            target={currentTab ? tabsRef[currentTab] : null}
            parent={tabsListRef}
            className={styles.indicator}
          />
        </Tabs.List>
      </Tabs>
    </div>
  );
};

export default CommunityTabs;
